import React from 'react';
import PropTypes from 'prop-types';

const Favicon = ({ className, filled}) => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="28" height="28" rx="14" fill="#1F1F1F"/>
        </svg>
    );
};

Favicon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
    filled: PropTypes.bool.isRequired, // Indicates whether the icon is filled
};

Favicon.defaultProps = {
    className: '', // Default to an empty string
};

export default Favicon;